(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('.welcome-popup');
    if (!popup) return;

    var storageKey = 'welcomePopupLastShown_' + popup.id;
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 4000;
    var frequencyHours = parseFloat(popup.getAttribute('data-frequency-hours')) || 24;
    var frequencyMs = frequencyHours * 60 * 60 * 1000;

    function hasBeenShownRecently() {
      try {
        var lastShown = localStorage.getItem(storageKey);
        if (!lastShown) return false;
        var elapsed = Date.now() - parseInt(lastShown, 10);
        return elapsed < frequencyMs;
      } catch (e) {
        // localStorage unavailable (private mode etc) - fail safe to "not shown"
        return false;
      }
    }

    function markAsShown() {
      try {
        localStorage.setItem(storageKey, Date.now().toString());
      } catch (e) {
        /* ignore */
      }
    }

    function showPopup() {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      markAsShown();
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (hasBeenShownRecently()) return;

    var closeTriggers = popup.querySelectorAll('[data-popup-close]');
    closeTriggers.forEach(function (el) {
      el.addEventListener('click', hidePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        hidePopup();
      }
    });

    window.setTimeout(showPopup, delay);
  });
})();